/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Copy_ResultsInputs */



/**
* | output |
* | --- |
* | "Copy results" |
*
* @param {Tools_Copy_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tools_copy_results = /** @type {((inputs?: Tools_Copy_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Copy_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier les résultats")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar resultados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Copiar resultados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia i risultati")
	return /** @type {LocalizedString} */ ("Copy results")
});